<template>
  <div>
    <button
      v-if="node.children && node.children.length"
      :href="node.url"
      :class="{ 'is-active': isActive }"
      :aria-expanded="childrenVisible"
      @click.prevent="toggleChildrenVisibility"
    >
      <slot></slot>
      <span>{{node.title}}</span>
      <svg v-if="toggleArrow" class="toggleIcon" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11 6">
        <path d="M5.304 5.529L10 .557M1 .557L5.696 5.53" stroke="#F27A6D"/>
      </svg>
    </button>
    <a
      v-else
      :href="node.url"
      :class="{ 'is-active': isActive }"
    >{{node.title}}
    </a>
      <transition name="fade">
        <ul v-show="childrenVisible" class="subnav bg-light" :aria-hidden="!childrenVisible">
          <li v-for="(child, index) in node.children" :key="index" class="navbar-item">
            <a :href="child.url">
              {{child.title}}
            </a>
          </li>
        </ul>
      </transition>
  </div>
</template>

<script>
import { eventBus } from '@global/eventBus'
export default {
  props: {
    toggleArrow: Boolean,
    node: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {
      childrenVisible: false
    }
  },
  methods: {
    toggleChildrenVisibility () {
      eventBus.$emit('toggleNav', this.unique)
      this.childrenVisible = !this.childrenVisible
    },
    async hideChildren (unique) {
      if (unique !== this.unique) {
        await this.wait(250)
        this.childrenVisible = false
      }
    },
    wait (ms) {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve('resolved')
        }, ms)
      })
    },
    onDocumentClick(e) {
      if (this.childrenVisible && this.isDesktop && !this.$el.contains(e.target)) {
        this.childrenVisible = false
      }
    },
    onKeyUp(e) {
      if (this.childrenVisible && this.isDesktop && e.keyCode === 27) {
        this.childrenVisible = false
      }
    }
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 1099;
    },
    isActive () {
      return this.node.active
    },
    unique () {
      return this.node.id || this.node.url
    }
  },
  mounted () {
    eventBus.$on('toggleNav', this.hideChildren)
    console.log('mounted')
    window.addEventListener('click', this.onDocumentClick)
    window.addEventListener('keyup', this.onKeyUp)
  },
  beforeDestroy () {
    window.removeEventListener('click', this.onDocumentClick)
    window.removeEventListener('keyup', this.onKeyUp)
  }
}
</script>

<style scoped lang="scss">
  .navbar-item {
    position: relative;
  }
  .subnav {
    position: absolute;
  }
  .toggleIcon {
    transition: transform 0.2s ease-in-out;
  }
  [aria-expanded="true"] .toggleIcon {
    transform: rotate(180deg);
  }
</style>
